import { render, staticRenderFns } from "./ReestrablecerPass.vue?vue&type=template&id=7c48bdb3&scoped=true&"
import script from "./ReestrablecerPass.vue?vue&type=script&lang=ts&"
export * from "./ReestrablecerPass.vue?vue&type=script&lang=ts&"
import style0 from "./ReestrablecerPass.vue?vue&type=style&index=0&id=7c48bdb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48bdb3",
  null
  
)

export default component.exports